import { fork } from 'redux-saga/effects';

import messagingPackageCheckoutSagas from './checkout/sagas';

const messagePackageSagas = [fork(messagingPackageCheckoutSagas)];

export default messagePackageSagas;
